import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-coupons-offers',
  standalone: true,
  imports: [CommonModule, FormsModule, BreadcrumComponent],
  templateUrl: './coupons-offers.component.html',
  styleUrl: './coupons-offers.component.scss',
})
export class CouponsOffersComponent implements OnInit {
  @Input() isStandalone: boolean = true;
  couponsBreadcrumbs: any[] = [{ label: 'Coupons & Offers', url: null }];
  showDropdown = false;
  showCategoryDropdown = false;
  showSellerDropdown = false;
  showAllDropdown = false;
  isMobileView = false;

  @ViewChild('dropdownRef') dropdownRef!: ElementRef;
  @ViewChild('categoryDropdownRef') categoryDropdownRef!: ElementRef;
  @ViewChild('sellerDropdownRef') sellerDropdownRef!: ElementRef;
  @ViewChild('allDropdownRef') allDropdownRef!: ElementRef;

  // @HostListener('document:click', ['$event'])

  constructor(private router: Router) {
    this.isMobileView = window.innerWidth <= 768;
  }

  ngOnInit(): void {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  selectedSeller: string = '';
  selectedOption: string = '';
  selectedCategory: string = '';

  categories: string[] = [
    'Axle',
    'Chassis',
    'Engine',
    'Electrical & Electronics',
    'Gearbox',
    'Glass',
    'Wheel, Tyre, Rim',
  ];

  toggleCategoryDropdown() {
    this.showCategoryDropdown = !this.showCategoryDropdown;
    this.showSellerDropdown = false;
    this.showDropdown = false;
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.showCategoryDropdown = false; // close after selection
  }
  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.showSellerDropdown = false;
    this.showCategoryDropdown = false;
  }

  selectOption(option: string) {
    this.selectedOption = option;
    this.showDropdown = false; // close after selecting
  }

  get selectedOptionLabel(): string {
    switch (this.selectedOption) {
      case 'recent':
        return 'Recently Added';
      case 'trending':
        return 'Trending';
      case 'expiring':
        return 'Expiring Soon';
      default:
        return 'Sort By';
    }
  }

  toggleSellerDropdown() {
    this.showSellerDropdown = !this.showSellerDropdown;
    this.showDropdown = false;
    this.showCategoryDropdown = false;
  }

  selectSeller(seller: string) {
    this.selectedSeller = seller;
    this.showSellerDropdown = false; // auto close after select
  }
  checkScreenSize() {
    this.isMobileView = window.innerWidth <= 768; // Tailwind md breakpoint
  }

  handleDocumentClick(event: MouseEvent) {
    const target = event.target as Node;

    if (this.dropdownRef && !this.dropdownRef.nativeElement.contains(target)) {
      this.showDropdown = false;
    }
    if (
      this.categoryDropdownRef &&
      !this.categoryDropdownRef.nativeElement.contains(target)
    ) {
      this.showCategoryDropdown = false;
    }
    if (
      this.sellerDropdownRef &&
      !this.sellerDropdownRef.nativeElement.contains(target)
    ) {
      this.showSellerDropdown = false;
    }
    if (
      this.allDropdownRef &&
      !this.allDropdownRef.nativeElement.contains(target)
    ) {
      this.showAllDropdown = false;
    }
  }

  onSelectChange(event: Event) {
    const selected = (event.target as HTMLSelectElement).value;
    console.log('Selected:', selected);
    this.showDropdown = false;
  }

  toggleAllDropdown() {
    this.showAllDropdown = !this.showAllDropdown;
  }

  selectAll(option: string) {
    console.log('Selected All option:', option);
    this.showAllDropdown = false;
  }

  Container_arr: any[] = [
    {
      id: 1,
      code: 'SELL05',
      description: 'Get upto ₹1,000 OFF on your purchase with this code',
      expiryDate: '25 May, 2025',
      offerStartDate: '1 May, 2025',
      preoffererMsg: 'Hurry! Offer in 2 days!',
      isActive: true,
    },
    {
      id: 2,
      code: 'ENGINE05',
      description: 'Get 10% off on engine category, on min spend of ₹5000',
      expiryDate: '25 May, 2025',
      offerStartDate: '1 May, 2025',
      preoffererMsg: 'Hurry! Offer in 2 days!',
      isActive: true,
    },
    {
      id: 3,
      code: 'BODYPANEL15',
      description: 'Get 15% off on base panels, on min spend of ₹5000',
      expiryDate: '2023-08-31',
      offerStartDate: '1 May, 2025',
      preoffererMsg: 'Hurry! Offer in 2 days!',
      isActive: false,
    },
  ];
}
